module.exports = __webpack_public_path__ + "static/media/konno-yuuki.8f73c8cb.png";